export default __webpack_public_path__ + "static/media/category_14.1142cad0.png";